import {DeepPartial} from 'redux';
import {t} from '../../../common/getTranslations';
import {NormalListViewItem as NormalListViewItemType} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {TrackEventObject} from '../../../logging/TrackEventObject.interface';
import {Dialog} from '../Dialog';
import {NormalListViewItem} from '../NormalListViewItem/NormalListViewItem';

interface Props {
  setList: NormalListViewItemType[];
  onClickSet: (id: string) => void;
  onClickCancel: VoidFunction;
  additionalTrackObj?: DeepPartial<TrackEventObject>;
  isMobile: boolean;
}

export function SetListDialog({
  setList,
  onClickSet,
  onClickCancel,
  additionalTrackObj,
  isMobile,
}: Props) {
  return (
    <Dialog
      data-test="set-list-dialog"
      isOpen={true}
      isUsingScrollBlock={false}
      isMobile={isMobile}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: 'popup',
          imp_provider: 'service',
          imp_type: 'vimp',
          layer1: '세트상품팝업',
        },
        ...(additionalTrackObj ?? {}),
      })}
      onInView={target => {
        aggregateAndSendLog({
          targetElem: target as HTMLElement,
          actionType: 'ViewImp',
          actionName: '팝업_노출',
          customProps: {
            user_action: 'imp',
            popup_type: '세트상품팝업',
          },
        });
      }}
      isList
    >
      <Dialog.Dimmed />
      <Dialog.Title>{t('contenthome_sethome_popup_title')}</Dialog.Title>
      <Dialog.List className="pb-20pxr pt-10pxr px-0 max-h-[539px] !space-y-0">
        {setList.map(item => {
          if (!item) {
            return null;
          }

          return (
            <NormalListViewItem
              data-test="set-item"
              onClick={e => {
                LOG_CLICK_EVENT('세트상품_클릭', e, () => onClickSet(item.id));
              }}
              key={item.id}
              isAgeRestricted={false}
              isSet
              item={item}
              {...putTiaraObjectProps({
                eventMeta: {
                  id: item.id,
                  type: 'setId',
                },
                click: {layer1: '세트상품팝업'},
                ...(additionalTrackObj ?? {}),
              })}
            />
          );
        })}
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('세트보러가기팝업_닫기_클릭', e, onClickCancel)
          }
        >
          {t('common_close_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
